// import React from 'react'


// const Head = () => {
//   return (
//     <>
//     <section className='head'>
//        <div className='container flexSB'>
//         <div className="Logo">
//         <img src="images/Pitcture.png" alt="logo" style={{ width: '100px', height: '100px', objectFit: 'contain' }} />
       
//               <h1>KISHALAY</h1>
//             <span>Play School  </span>
//         </div>

//           <div className='social'>
//             <i className = 'fab fa-facebook-f icon'></i>
//             <i className = 'fab fa-instagram icon'></i>
//             <i className='fab fa-youtube icon'></i>
//           </div>
//        </div>
//     </section>
      
//     </>
//   )
// }

// export default Head


// import React from 'react';
// import './head.css'; // Add a separate CSS file for styling and animations

// const Head = () => {
//   return (
//     <>
//       <section className="head">
//         <div className="container flexSB">
//           <div className="Logo">
//             <img
//               src="images/Pitcture.png"
//               alt="logo"
//               className="logo-animation"
//               style={{ width: '100px', height: '100px', objectFit: 'contain' }}
//             />
//             <img
//               src="images/tyy.png"
//               alt="KISHALAY Play School"
//               className="kishalay-logo"
//               style={{ width: '300px', height: 'auto', objectFit: 'right ' }}
//             />
//           </div>

         

          
//         </div>
//       </section>
//     </>
//   );
// };

// export default Head;


import React from 'react';
import './head.css'; // Add a separate CSS file for styling and animations

const Head = () => {
  return (
    <>
      <section className="head">
        <div className="container">
          <div className="Logo">
            <img
              src="images/Pitcture.png"
              alt="logo"
              className="logo-animation"
            />
          </div>

          {/* Center the Kishalay text image */}
          <div className="kishalay-container">
            <img
              src="images/tyy.png"
              alt="KISHALAY Play School"
              className="kishalay-logo"
            />
          </div>

          <div className="social">
            <i className="fab fa-facebook-f icon"></i>
            <i className="fab fa-instagram icon"></i>
            <i className="fab fa-youtube icon"></i>
          </div>
        </div>
      </section>
    </>
  );
};

export default Head;
